import { transformPreviewDomain } from 'utils/preview'

export const origin =
  typeof window !== 'undefined' && window.location.origin
    ? window.location.origin
    : ''

/**
 * Get the current payments domain, correctly handling preview environments.
 *
 * For preview environments (e.g., ribeiro-pr3327.staging.alternativepayments.io),
 * this returns the transformed domain (ribeiro.staging.alternativepayments.io)
 * to match what's stored in the database.
 *
 * @returns The payments domain, or empty string if called during SSR
 */
export const getPaymentsDomain = (): string => {
  if (typeof window === 'undefined') return ''

  if (process.env.NEXT_PUBLIC_PORTAL_DOMAIN) {
    return process.env.NEXT_PUBLIC_PORTAL_DOMAIN
  }

  const currentOrigin = window.location.origin
  if (!currentOrigin) return ''

  const domain = currentOrigin.includes('://')
    ? currentOrigin.split('://')[1]
    : ''

  return transformPreviewDomain(domain)
}
